export default __webpack_public_path__ + "static/media/pvilla3-3.50935802.webp";